export const TKeyFAQ = {
  FAQ: "FAQ",
  FAQ_TITLE: "FAQ_TITLE",
  FAQ_MEIDLY_1_TITLE: "FAQ_MEIDLY_1_TITLE",
  FAQ_MEIDLY_1_TEXT: "FAQ_MEIDLY_1_TEXT",
  FAQ_MEIDLY_1_TEXT_2: "FAQ_MEIDLY_1_TEXT_2",
  FAQ_MEIDLY_2_TITLE: "FAQ_MEIDLY_2_TITLE",
  FAQ_MEIDLY_2_TEXT: "FAQ_MEIDLY_2_TEXT",
  FAQ_MEIDLY_2_TEXT_2: "FAQ_MEIDLY_2_TEXT_2",
  FAQ_MEIDLY_2_TEXT_3: "FAQ_MEIDLY_2_TEXT_3",
  FAQ_MEIDLY_3_TITLE: "FAQ_MEIDLY_3_TITLE",
  FAQ_MEIDLY_3_TEXT: "FAQ_MEIDLY_3_TEXT",
  FAQ_MEIDLY_3_TEXT_2: "FAQ_MEIDLY_3_TEXT_2",
  FAQ_MEIDLY_4_TITLE: "FAQ_MEIDLY_4_TITLE",
  FAQ_MEIDLY_4_TEXT: "FAQ_MEIDLY_4_TEXT",
  FAQ_MEIDLY_4_TEXT_2: "FAQ_MEIDLY_4_TEXT_2",
  FAQ_MEIDLY_4_TEXT_3: "FAQ_MEIDLY_4_TEXT_3",
  FAQ_MEIDLY_5_TITLE: "FAQ_MEIDLY_5_TITLE",
  FAQ_MEIDLY_5_TEXT: "FAQ_MEIDLY_5_TEXT",
  FAQ_MEIDLY_5_TEXT_2: "FAQ_MEIDLY_5_TEXT_2",
  FAQ_MEIDLY_6_TITLE: "FAQ_MEIDLY_6_TITLE",
  FAQ_MEIDLY_6_TEXT: "FAQ_MEIDLY_6_TEXT",
  FAQ_MEIDLY_6_TEXT_2: "FAQ_MEIDLY_6_TEXT_2",
  FAQ_MEIDLY_7_TITLE: "FAQ_MEIDLY_7_TITLE",
  FAQ_MEIDLY_7_TEXT: "FAQ_MEIDLY_7_TEXT",
  FAQ_MEIDLY_7_TEXT_2: "FAQ_MEIDLY_7_TEXT_2",
  FAQ_MORE_TITLE: "FAQ_MORE_TITLE",
  FAQ_MORE_TEXT: "FAQ_MORE_TEXT",
} as const;
